// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceSaveAction } from "abweb/dto/generated/ds/DataSourceSaveAction";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
export class DataSourceValueBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceValue";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceValue(json.attributeValues != null ? json.attributeValues : null, json.clientTag != null ? json.clientTag : null, json.dataSourceSaveAction != null ? DataSourceSaveAction.fromJson(json.dataSourceSaveAction) : null, json.editableOverwrite != null ? json.editableOverwrite : null, json.id != null ? json.id : null, json.state != null ? DataSourceState.fromJson(json.state) : null);
  }
  initDataSourceValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state) {
    this.initKendoObservableObjectProxy();
    this._attributeValues = attributeValues;
    this._clientTag = clientTag;
    this._dataSourceSaveAction = dataSourceSaveAction;
    this._editableOverwrite = editableOverwrite;
    this._id = id;
    this._state = state;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._attributeValues != null) {
      retVal["attributeValues"] = this._attributeValues;
    }
    if (this._clientTag != null) {
      retVal["clientTag"] = this._clientTag;
    }
    if (this._dataSourceSaveAction != null) {
      retVal["dataSourceSaveAction"] = this._dataSourceSaveAction;
    }
    if (this._editableOverwrite != null) {
      retVal["editableOverwrite"] = this._editableOverwrite;
    }
    if (this._id != null) {
      retVal["id"] = this._id;
    }
    if (this._state != null) {
      retVal["state"] = this._state;
    }
    return retVal;
  }
  get attributeValues() {
    return this._attributeValues;
  }
  set attributeValues(value) {
    this._attributeValues = value;
  }
  get clientTag() {
    return this._clientTag;
  }
  set clientTag(value) {
    this._clientTag = value;
  }
  get dataSourceSaveAction() {
    return this._dataSourceSaveAction;
  }
  set dataSourceSaveAction(value) {
    this._dataSourceSaveAction = value;
  }
  get editableOverwrite() {
    return this._editableOverwrite;
  }
  set editableOverwrite(value) {
    this._editableOverwrite = value;
  }
  get id() {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }
  get state() {
    return this._state;
  }
  set state(value) {
    this._state = value;
  }
}
//# sourceMappingURL=DataSourceValueBase.js.map
